export const Scripts: ModdedBattleScriptsData = {
	inherit: 'base'
};
